import React from 'react';
import dynamic from 'next/dynamic';
import { getLocator, isSafariBrowser } from '@tcp/core/src/utils';
import Modal from '../../../../../../../common/molecules/Modal';
import { modalStyles } from '../../../../../../../common/organisms/QuickViewModal/styles/QuickViewModalModalAnimation.style';
import styles from './styles/PlccICLoginModal.view.style';
import withStyles from '../../../../../../../common/hoc/withStyles';
import { getDynamicLabelValues } from '../../../../../../../../utils/labels/labelUtilty';

const LoginPageContainer = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "login-page" */ '@tcp/core/src/components/features/account/LoginPage'
    ),
  { ssr: false }
);

const PlccICLoginModal = (props) => {
  const { isLoginModalOpen, className, closeModal } = props;

  const modalHeadingNewQV = {
    className: 'modal-heading',
  };
  const isSafari = isSafariBrowser();
  if (isLoginModalOpen) {
    setTimeout(() => {
      document.querySelector('.TCPModal__InnerContent')?.scrollTo(0, 0);
    }, 500);
  }
  return (
    <div>
      <Modal
        fixedWidth
        isOpen={isLoginModalOpen}
        onRequestClose={closeModal}
        heading={getDynamicLabelValues('dynamic.cart.lbl_plcc_ic_login_modal_header')}
        headingAlign="center"
        overlayClassName="TCPModal__Overlay"
        dataLocator={getLocator('quick_view_modal')}
        dataLocatorHeader={getLocator('quick_view_add_to_bag_header')}
        closeIconDataLocator={getLocator('quick_view_icon_btn')}
        className={`TCPModal__Content, ${className}`}
        inheritedStyles={modalStyles}
        innerContentClassName={`atb-innerContent`}
        headingFontWeight="bold"
        headingFontFamily="secondary"
        isSafari={isSafari}
        stickyHeader
        fontSize="fs22"
        headingStyle={modalHeadingNewQV}
      >
        {
          <div className="outerCont">
            <LoginPageContainer fromPlccICLogin />
          </div>
        }
      </Modal>
    </div>
  );
};

PlccICLoginModal.propTypes = {};

PlccICLoginModal.defaultProps = {};

export default withStyles(PlccICLoginModal, styles);
export { PlccICLoginModal as PlccICLoginModalVanilla };
